const isEditing = "isEditing";
const isReadOnly = "isReadOnly";

export { isEditing, isReadOnly };
